import Moment from "react-moment";
import React from "react";
import 'moment-timezone';

export const DateTimeFormat = function(props) {
    let format = 'YYYY/MM/DD HH:mm:ss';

    if(props.value === null) {
        return <span>Unavailable</span>;
    }

    if(typeof props.format !== 'undefined') {
        format = props.format;
    }

    return <Moment date={props.value} format={format} withTitle tz='UTC' />;
};